import { forEach } from '../../utils/array-utils';

const GALLERY_ITEM = '.j-gallery-item';

/**
 * Utility function for validate HASH for gallery
 * @param {string} actualPageHash current hash
 */
const isValidHashInGallery = (actualPageHash) => {
  let isValid = false;
  const nextLinkNodeList = document.querySelectorAll(GALLERY_ITEM);
  forEach((elm) => {
    if (elm.id === actualPageHash) {
      isValid = true;
    }
  })(nextLinkNodeList);
  return isValid;
};

/**
 *
 * @param {*} previousHash
 */
export const onGalleyHashChanged = (previousHash) => {
  const url = location.href;
  let urlRef = '';
  let currentPage = '';
  const indexPage = url.lastIndexOf('#');
  const currentPageHash = url.substring(indexPage + 1, url.length);
  if (indexPage === -1 || currentPageHash === '00' || isValidHashInGallery(currentPageHash)) {
    if (indexPage === -1) {
      return { url: `${url}?slide=1`, urlRef: location.href, previousHash };
    } else if (currentPageHash === '00') {
      return { url: `${url.substring(0, indexPage)}?slide=1`, urlRef: url.substring(0, indexPage), previousHash };
    }
    currentPage = url.substring(indexPage + 1, url.length);
    urlRef = `${url.substring(0, indexPage)}?slide=${Number(currentPage)}`;

    if (previousHash !== currentPageHash) {
      return { url: urlRef, urlRef: url.substring(0, indexPage), currentPageHash };
    }
  }
  console.error('is not valid hash in gallery');
  return undefined;
};

/**
 * On News U Can Use card change
 * @param {*} currentCardId
 */

export const onNewsUCanUseCardChange = (currentCardId) => {
  const urlRef = location.origin + location.pathname;
  if (currentCardId) {
    let url = urlRef;
    url += `?card=${currentCardId}`;
    return { url, urlRef };
  }
  return undefined;
};
